export const dateToLocalFormat = (selectedDate: Date | undefined ) => {
  return selectedDate
    ? `${selectedDate.getFullYear()}-${(selectedDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${selectedDate.getDate().toString().padStart(2, '0')}`
    : undefined;
};
